import { useLocation, Link } from 'react-router-dom';
import {
  FiArrowLeft,
  FiZap,
  FiTrendingUp,
  FiAward,
  FiBookOpen,
  FiCode,
  FiLink,
  FiNavigation,
} from 'react-icons/fi';

const PAGE_META = {
  '/defi': { title: 'DeFi Dashboard', Icon: FiTrendingUp },
  '/leaderboard': { title: 'Leaderboard', Icon: FiAward },
  '/resources': { title: 'Resources', Icon: FiBookOpen },
  '/developers': { title: 'Developer Center', Icon: FiCode },
  '/addresses': { title: 'Top Addresses', Icon: FiLink },
};

const FALLBACK = { title: 'This Page', Icon: FiNavigation };

export default function ComingSoonPage() {
  const { pathname } = useLocation();
  const { title, Icon } = PAGE_META[pathname] || FALLBACK;

  return (
    <main className="cs-page">
      <div className="cs-bg-grid" aria-hidden="true" />

      <div className="cs-container">
        <div className="cs-glow" aria-hidden="true" />

        <div className="cs-badge">
          <FiZap className="cs-badge-icon" />
          <span>In Development</span>
        </div>


        <h1 className="cs-title">{title}</h1>

        <div className="cs-divider" aria-hidden="true">
          <span className="cs-divider-dot" />
          <span className="cs-divider-line" />
          <span className="cs-divider-dot" />
        </div>

        <p className="cs-heading">Coming Soon</p>
        <p className="cs-desc">
          We&apos;re building something amazing. This feature is currently
          under active development and will be available shortly.
        </p>

        <Link to="/" className="cs-back-btn">
          <FiArrowLeft />
          <span>Back to Home</span>
        </Link>

        <div className="cs-dots" aria-hidden="true">
          <span className="cs-dot cs-dot--1" />
          <span className="cs-dot cs-dot--2" />
          <span className="cs-dot cs-dot--3" />
        </div>
      </div>
    </main>
  );
}
